import {
  ApiDeleteRequest,
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Journal Umum',
    title_form: 'Form Journal Umum',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Journal Umum',
        href: '/adm/fin/buku-besar/journal-umum',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_journal',
    sortDesc: true,
    fields: [
      {
        key: 'code_journal',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'date_journal',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'reference',
        label: 'Reference',
        sortable: true,
      },
      {
        key: 'notes',
        label: 'Notes',
        sortable: true,
      },
      {
        key: 'total',
        label: 'Total',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {
      date_journal: '',
      notes: '',
      items: [
        {
          id_account: '',
          id_department: '',
          description: '',
          debet: '',
          kredit: '',
        },
      ],
    },
    journal: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeJournal(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getJournal({ commit, state }) {
    commit('changeJournal', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest('fin/journal', params);
    commit('changeJournal', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailJournal({ commit, state }, payload = null) {
    commit('changeJournal', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/journal/${payload.id}`);
    commit('changeJournal', {
      loading: false,
    });

    if (!result.error) {
      commit('changeJournal', {
        form: {
          ...data.form,
          ...result.data.object,
          date_journal: result.data.object.date_journal
            ? moment(result.data.object.date_journal).format('DD/MM/YYYY')
            : '',
        },
      });

      return true;
    }

    return false;
  },

  async getLastId({ commit, state }) {
    commit('changeJournal', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/journal/get_last_id`);
    commit('changeJournal', {
      loading: false,
    });

    if (!result.error) {
      commit('changeJournal', {
        form: {
          ...data.form,
          code_journal: result.data.object,
        },
      });

      return true;
    }

    return false;
  },

  async createJournal({ commit, state, dispatch }) {
    commit('changeJournal', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('fin/journal', data.form);

    commit('changeJournal', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateJournal({ commit, state, dispatch }, payload = null) {
    commit('changeJournal', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(`fin/journal/${payload.id}`, data.form);

    commit('changeJournal', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async deleteJournal({ commit, dispatch }, payload = null) {
    commit('changeJournal', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/journal/${payload.id}`);
    commit('changeJournal', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async getDetailSetupAccount({ commit }, payload = null) {
    commit('changeJournal', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/journal/${payload.id}`);
    commit('changeJournal', {
      loading: false,
    });

    if (!result.error) {
      commit('changeJournal', {
        detail: result.data.object,
      });
    }

    return !result.error ? true : false;
  },
};
